/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type { XXB, XXBInterface } from "../XXB";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "allowance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256",
      },
    ],
    name: "ERC20InsufficientAllowance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256",
      },
    ],
    name: "ERC20InsufficientBalance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address",
      },
    ],
    name: "ERC20InvalidApprover",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "ERC20InvalidReceiver",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "ERC20InvalidSender",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "ERC20InvalidSpender",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "buy",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type XXBConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: XXBConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class XXB__factory extends ContractFactory {
  constructor(...args: XXBConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      XXB & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): XXB__factory {
    return super.connect(runner) as XXB__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): XXBInterface {
    return new Interface(_abi) as XXBInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): XXB {
    return new Contract(address, _abi, runner) as unknown as XXB;
  }
}
